/* =============================================================================
   App.jsx  —  root. Routes between the guest page and the host panel.
   Guest:  default view.
   Admin:  #admin in the hash, or /admin in the path.
============================================================================= */
import { useState, useEffect } from 'react';
import { GuestPage } from './components/guest';
import { AdminApp } from './components/admin';

function isAdminRoute() {
  return (
    window.location.hash.replace('#', '').toLowerCase() === 'admin' ||
    /\/admin\/?$/.test(window.location.pathname)
  );
}

export default function App() {
  const [admin, setAdmin] = useState(isAdminRoute());
  useEffect(() => {
    const onHash = () => {
      const nowAdmin = isAdminRoute();
      setAdmin((wasAdmin) => {
        // Only scroll to top when leaving the admin panel back to the guest
        // page. Do NOT scroll on in-page section navigation (#registry, #faq,
        // ...), which would otherwise fight the browser's anchor jump.
        if (wasAdmin && !nowAdmin) window.scrollTo({ top: 0 });
        return nowAdmin;
      });
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  return admin ? <AdminApp /> : <GuestPage />;
}
